export const IOM = 'IoM';
export const UK = 'UK';
export const FITBANK = 'FitBank';
